"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrcadPinNameForRendering = getOrcadPinNameForRendering;
const ModelText = require("../../ModelText");
function getOrcadPinNameForRendering(text, pinStart) {
    const display = ModelText.resolveDisplayText({ raw: text.value.toString(), dialects: [ModelText.TextDialect.Orcad] });
    if (display.transforms.length === 0) {
        return text;
    }
    const renderingText = {
        ...text,
        value: display.text,
        textTransforms: [...(text.textTransforms ?? []), ...display.transforms],
    };
    const rawHalfWidth = (text.value.toString().length * text.size) / 2;
    const displayHalfWidth = (renderingText.value.toString().length * text.size) / 2;
    const [x, y] = text.pos;
    const [pinX, pinY] = pinStart;
    const horizontalOffset = x - pinX;
    const verticalOffset = y - pinY;
    const positionTolerance = Math.max(1, text.size) * 1e-6;
    if (Math.abs(Math.abs(horizontalOffset) - rawHalfWidth) <= positionTolerance &&
        Math.abs(verticalOffset) <= positionTolerance) {
        return { ...renderingText, pos: [pinX + Math.sign(horizontalOffset) * displayHalfWidth, y] };
    }
    if (Math.abs(Math.abs(verticalOffset) - rawHalfWidth) <= positionTolerance &&
        Math.abs(horizontalOffset) <= positionTolerance) {
        return { ...renderingText, pos: [x, pinY + Math.sign(verticalOffset) * displayHalfWidth] };
    }
    return renderingText;
}
//# sourceMappingURL=getOrcadPinNameForRendering.js.map